<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" :content="id ? '编辑管理员' : '添加管理员'"></el-page-header>
		<el-form label-position="right" :rules="rules" ref="ruleForm" :model="item" label-width="auto">
			<el-form-item label="账号" prop="seller_name">
				<el-input v-model="item.seller_name" placeholder="请输入账号"></el-input>
			</el-form-item>
			<el-form-item label="角色" prop="">
				<el-select clearable v-model="item.role_id" placeholder="请选择角色">
					<el-option :label="val.name" :value="val.id" v-for="(val, key) in roles" :key="key"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="密码">
				<el-input clearable v-model="item.password" placeholder="请输入密码"></el-input>
			</el-form-item>
			<el-form-item label="状态">
				<el-radio-group v-model="item.status">
					<el-radio :label="1">正常</el-radio>
					<el-radio :label="0">锁定</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submit">保存</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
export default {
	data() {
		return {
			item: {
				status: 1
			},
			isLoad: false,
			id: this.$route.query.id,
			roles:[],
			rules: {
				seller_name: [
					{
						required: true,
						validator: this.$check.mobile,
						trigger: 'blur'
					}
				],
				role_id: [
					{required: true, message: '请选择角色'},
				],
			}
		}
	},
	created() {
		this.loadRoles()
		this.loadData()
	},
	methods: {
		loadRoles() {
			this.isLoad = !this.isLoad
			this.axios.get('store/role/index',{params:{
				}}).then(res => {
				this.isLoad = !this.isLoad
				this.roles = res.data.list
			}).catch(() => {
				this.isLoad = !this.isLoad
			})
		},
		loadData() {
			if (this.id) {
				this.isLoad = !this.isLoad
				this.axios.get('store/seller/detail',{params:{
						id:this.id
					}}).then(res => {
					this.isLoad = !this.isLoad
					this.item = res.data.detail
					this.item.role_id = this.item.role_id ? this.item.role_id : ''
				}).catch(() => {
					this.isLoad = !this.isLoad
				})
			}
		},
		goBack() {
			this.$router.back(-1)
		},
		async submit() {
			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
					this.isLoad = !this.isLoad
					let url = ''
					if (this.id)
						url = '/store/seller/edit'
					else
						url = '/store/seller/add'
					try{

						this.axios.post(url,{
							id:this.id,
							seller_name:this.item.seller_name,
							role_id:this.item.role_id,
							status:this.item.status,
							password:this.item.password,
						}).then(res => {
							this.isLoad = !this.isLoad
							this.$message.success({
								message: '保存成功'
							});
							this.goBack()
						}).catch(() => {
							this.isLoad = !this.isLoad
						})

					}catch(error){
						this.isLoad = !this.isLoad
					}
				} else {
					this.$message.warning("请检查表单信息是否正确");
					return false;
				}
			});
		}
	}
}
</script>
<style>
</style>
